import { environment } from "../../../../environments/environment";

export class AppConstants {

    // public static BASE_URL = 'http://10.17.74.102/SSRMAPI/api';
    // public static BASE_URL = 'http://10.1.10.96:8088/SSRMAPI/api';
    //  public static BASE_URL = 'http://voucher.vietnamairlines.com:7073/SSRMAPI/api';
    // public static BASE_URL = 'https://localhost:44366/api';
    // public static UPLOAD_FOLDER = 'https://localhost:44366/FileUpload';
    // public static UPLOAD_FOLDER = 'http://10.17.74.102/SSRMAPI/FileUpload/';
    //  public static UPLOAD_FOLDER = 'http://voucher.vietnamairlines.com:7073/SSRMAPI/FileUpload';
    // public static BASE_URL = 'http://lotusawardsqa.vietnamairlines.com:8088/SSRMAPI/api';
    // public static UPLOAD_FOLDER = ' http://lotusawardsqa.vietnamairlines.com:8088/SSRMAPI/FileUpload/';
    public static BASE_URL = environment.apiURL;
    public static UPLOAD_FOLDER = environment.uploadfileUrl;

    // Login Api
    public static LOGIN = AppConstants.BASE_URL + '/Auth/GetToken';
    public static REGISTER = AppConstants.BASE_URL + '/Auth/Register';

    // User Api
    public static GET_USERS_BY_FILTER = AppConstants.BASE_URL + '/Configuration/GetUsersByFilter?';
    public static GET_USER_DETAIL = AppConstants.BASE_URL + '/Configuration/GetUserDetail?id=';
    public static GET_ALL_OFFICES = AppConstants.BASE_URL + '/Configuration/GetAllOffices';
    public static GET_ALL_ROLES = AppConstants.BASE_URL + '/Configuration/GetAllRoles';
    public static GET_ALL_RIGHTS = AppConstants.BASE_URL + '/Configuration/GetAllRights';
    public static GET_ALL_MENUS = AppConstants.BASE_URL + '/Configuration/GetAllMenus';
    public static UPDATE_USER_AND_GRANT_RIGHT = AppConstants.BASE_URL + '/Configuration/UpdateUserAndGrantRight';
    public static CREATE_USER = AppConstants.BASE_URL + '/Configuration/CreateUser';

    // Office Api
    public static GET_OFFICES_BY_FILTER = AppConstants.BASE_URL + '/Configuration/GetOfficesByFilter?';
    public static GET_OFFICE_DETAIL = AppConstants.BASE_URL + '/Configuration/GetOfficeDetail?id=';
    public static UPDATE_OFFICE = AppConstants.BASE_URL + '/Configuration/UpdateOffice';
    public static CREATE_OFFICE = AppConstants.BASE_URL + '/Configuration/CreateOffice';

    // Role Api
    public static GET_ROLES_BY_FILTER = AppConstants.BASE_URL + '/Configuration/GetRolesByFilter?';
    public static GET_ROLE_DETAIL = AppConstants.BASE_URL + '/Configuration/GetRoleDetail?id=';
    public static UPDATE_ROLE = AppConstants.BASE_URL + '/Configuration/UpdateRole';
    public static CREATE_ROLE = AppConstants.BASE_URL + '/Configuration/CreateRole';

    // Right Api
    public static GET_RIGHTS_BY_FILTER = AppConstants.BASE_URL + '/Configuration/GetRightsByFilter?';

    // Login Api
    public static GET_ALL_OFFICES_ACTIVE = AppConstants.BASE_URL + '/Office/GetAllOfficeActive';

    // Special Meal Api
    public static CREATE_SPECIAL_MEAL = AppConstants.BASE_URL + '/SpecialMeals/Create';
    public static UPDATE_SPECIAL_MEAL = AppConstants.BASE_URL + '/SpecialMeals/Update';
    public static GET_SPECIAL_MEAL_DETAIL = AppConstants.BASE_URL + '/SpecialMeals/';
    public static GET_SPECIAL_MEAL_BY_FILTER = AppConstants.BASE_URL + '/SpecialMeals?';
    public static DELETE_SPECIAL_MEAL = AppConstants.BASE_URL + '/SpecialMeals/';

    // Request Api
    public static GET_REQUESTS_BY_FILTER = AppConstants.BASE_URL + '/SsrRequest?';
    public static GET_REQUESTS_DETAIL = AppConstants.BASE_URL + '/SsrRequest/';
    public static CONFIRM_REQUEST = AppConstants.BASE_URL + '/SsrRequest/ConfirmRequest';
    public static REJECT_REQUEST = AppConstants.BASE_URL + '/SsrRequest/RejectRequest';
    public static EXPORT_REQUEST = AppConstants.BASE_URL + '/SsrRequest/ExportRequests?';
    public static GetItemDisplays = AppConstants.BASE_URL + '/common/GetItemDisplays?Group=';
    // report Api
    public static REPORT_BY_REQUEST_STATUS = AppConstants.BASE_URL + '/Report/ReportRequestByStatus/?';
    public static REPORT_SALES_SPECIALSERVICE = AppConstants.BASE_URL + '/Report/ReportSaleSpecialService';
    public static REPORT_SALES_SPECIALSERVICE_EXPORT = AppConstants.BASE_URL + '/Report/ExportReportSale';
    public static REPORT_BOOKING_BUZ_MEAL = AppConstants.BASE_URL + '/Report/GetBuzMealBookingReport';
    public static REPORT_BOOKING_BUZ_MEAL_BY_PERIOD = AppConstants.BASE_URL + '/Report/GetBuzMealBookingByPeriodReport';
    public static REPORT_BOOKING_BUZ_MEAL_EXPORT = AppConstants.BASE_URL + '/Report/ExportBuzMealBookingReport';
    public static REPORT_BOOKING_BUZ_MEAL_EXPORT_BY_PERIOD = AppConstants.BASE_URL + '/Report/ExportBuzMealBookingByPeriodReport';
    // buz meal api 
    public static IMPORT_GET_BY_PAGE = AppConstants.BASE_URL + '/BuzMealManagement/GetListFileImport?';
    public static CHECK_IMPORT_MENU_FLIGHT = AppConstants.BASE_URL + '/BuzMealManagement/CheckImportMenu'; 
    public static IMPORT_MENU_FLIGHT = AppConstants.BASE_URL + '/BuzMealManagement/ImportMenu'; 
    public static GET_BY_PAGE_FLIGHT_MENU = AppConstants.BASE_URL + '/BuzMealManagement/GetListFlightMenu?';
    public static GET_FLIGHT_MENU_DETAIL = AppConstants.BASE_URL + '/BuzMealManagement/GetFlightMenuDetail/';
    public static UPDATE_FLIGHT_MENU_DETAIL = AppConstants.BASE_URL + '/BuzMealManagement/UpdateFlightApply';
    public static CHECK_FLIGHT_MENU_DETAIL = AppConstants.BASE_URL + '/BuzMealManagement/CheckFlightApply';
    public static UPDATE_BUZMEAL_INFO = AppConstants.BASE_URL + '/BuzMealManagement/UpdateDetailDishInfo';
    public static CREATE_BUZMEAL_INFO = AppConstants.BASE_URL + '/BuzMealManagement/CreateDish';
    public static GET_LIST_BUZMEAL_INFO = AppConstants.BASE_URL + '/BuzMealManagement/GetListBuzMealInfor';
    public static GET_DETAIL_BUZMEAL_INFO = AppConstants.BASE_URL + '/BuzMealManagement/GetDetailBuzMealInfor/';
    public static GET_DISH_TYPE_LIST = AppConstants.BASE_URL + '/BuzMealManagement/GetAllBuzMealDish';
    public static GET_MENU_LIST = AppConstants.BASE_URL + '/BuzMealManagement/GetAllBuzMealMenu';
    public static GET_BOOKING_BY_PNR = AppConstants.BASE_URL + '/BuzMeal/GetBookingInfoByPnrCode';
    public static GET_BOOKING_BY_TICKET_NUMBER = AppConstants.BASE_URL + '/BuzMeal/GetBookingInfoByTicketNumber';
    public static CREATE_BUZMEAL_REQUEST = AppConstants.BASE_URL + '/BuzMeal/CreateBuzMealRequest';
    public static SEND_EMAIL_BUZMEAL = AppConstants.BASE_URL + '/BuzMealManagement/SendMailBuzmeal';
    
    // Token
    public static TOKEN = 'Token';

    // Status
    public static statusList = [
        { value: 0, displayName: 'Deactive' },
        { value: 1, displayName: 'Active' },
        { value: 2, displayName: 'Pending' },
    ];

    // Language
    public static languageList = [
        { value: 'vi', displayName: 'Tiếng Việt' },
        { value: 'en', displayName: 'English' },
    ];

    // Status
    public static specialMealStatusList = [
        { value: false, displayName: 'Deactive' },
        { value: true, displayName: 'Active' },
    ];

    // Type
    public static specialMealTypeList = [
        { value: '1', displayName: 'Suất ăn chay' },
        { value: '2', displayName: 'Suất ăn cho trẻ sơ sinh và trẻ em' },
        { value: '3', displayName: 'Suất ăn theo tôn giáo' },
        { value: '4', displayName: 'Suất ăn theo chế độ y khoa' },
        { value: '5', displayName: 'Suất ăn đặc biệt khác' },
    ];
    // BuzMealStatus
    public static buzMealsStatusList = [
        { value: false, displayName: 'Deactive' },
        { value: true, displayName: 'Active' },
    ];

    // Type
    public static buzMealsTypeList = [
        { value: '1', displayName: 'Breakfast' },
        { value: '2', displayName: 'Lunch' },
        { value: '3', displayName: 'Dinner' },
    ];
    public static typeOfDishList = [
        { value: '1', displayName: 'Món chính' },
    ];

    //
    public static endTail = '@fsoft.com.vn';


    // Service Special Type
    public static serviceSpecialType = [
        { id: 0, serviceName: '' },
        { id: 1, serviceName: 'Pregnant' },
        { id: 2, serviceName: 'Medifi' },
        { id: 3, serviceName: 'BlindDeafDnpa' },
        { id: 4, serviceName: 'SpecialBaggage' },
        { id: 5, serviceName: 'BassinetForInfant' },
        { id: 6, serviceName: 'ExtraSeat' },
        { id: 7, serviceName: 'MeetGreet' },
    ];
    //
    public static downloadFileExcel(data, name) {
        const blob = new Blob([(data as any)], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', name + '.xls');
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);
    }
    public static downloadFilePDF(data, name) {
        const blob = new Blob([(<any>data)], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', name + '.pdf');
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);
        // console.log();
    }
}
